var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TotalText',{attrs:{"x":_vm.x,"y":_vm.y,"color":_vm.color}},[_vm._v(_vm._s(_vm.isTotal ? 'Total' : _vm.serie))])}
var staticRenderFns = []

export { render, staticRenderFns }